import { render, staticRenderFns } from "./PageSettingsDefault.vue?vue&type=template&id=501355ea"
import script from "./PageSettingsDefault.vue?vue&type=script&lang=ts"
export * from "./PageSettingsDefault.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports